import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SellerLayout from './components/SellerLayout';
import WithoutRequests from './components/RequestComponents/WithoutRequests';
import WithRequests from './components/RequestComponents/WithRequests';
import { getAllPartRequest } from './reduxStore/entities/partRequest';

const RequestPage = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  const partRequestData = useSelector((state) => state.partRequests.allPartRequest?.rows || []);

  useEffect(() => {
    const fetchRequests = async () => {
      await dispatch(getAllPartRequest({ state: [] }));
      setLoading(false);
    };
    fetchRequests();
  }, [dispatch]);

  if (loading) return null;

  return (
    <div className="request-page" style={styles.pageContainer}>
      <SellerLayout>
        <div style={styles.topMargin}>
          <div style={styles.flexRow}>
          </div>
        </div>
        {partRequestData?.length > 0 ? (
          <WithRequests />
        ) : (
          <WithoutRequests />
        )}
      </SellerLayout>
    </div>
  );
};

export default RequestPage;

const styles = {
  pageContainer: {
    backgroundColor: '#FFF',
    minHeight: '100vh',
  },
  topMargin: {
    marginBottom: '30px',
    marginTop: '20px',
  },
  flexRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginLeft: '20px',
    marginBottom: '10px',
  },
};
